<mat-drawer-container class="main-layout">
  <mat-drawer mode="side" opened>
    <app-menu class="menu" (collapsedChange)="onMenuCollapsed()"></app-menu>
  </mat-drawer>
  <mat-drawer-content class="content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>